import type { StateCreator } from 'zustand';
import type { BudgetAdjustment } from '@abs/shared-types';
import { generateId } from '@/utils/id';

export interface BudgetAdjustmentSlice {
  budgetAdjustments: BudgetAdjustment[];

  addBudgetAdjustment: (adjustment: Omit<BudgetAdjustment, 'id' | 'createdAt'>) => string;
  deleteBudgetAdjustment: (id: string) => void;
  deleteAdjustmentsByCourse: (courseId: string) => void;
}

export const createBudgetAdjustmentSlice: StateCreator<BudgetAdjustmentSlice> = (set) => ({
  budgetAdjustments: [],

  addBudgetAdjustment: (adjustmentData) => {
    const id = generateId();
    const adjustment: BudgetAdjustment = {
      ...adjustmentData,
      id,
      createdAt: new Date().toISOString(),
    };
    set((state) => ({
      budgetAdjustments: [...state.budgetAdjustments, adjustment],
    }));
    return id;
  },

  deleteBudgetAdjustment: (id) => {
    set((state) => ({
      budgetAdjustments: state.budgetAdjustments.filter((a) => a.id !== id),
    }));
  },

  deleteAdjustmentsByCourse: (courseId) => {
    set((state) => ({
      budgetAdjustments: state.budgetAdjustments.filter((a) => a.courseId !== courseId),
    }));
  },
});
